import React from 'react';
import { WeeklyDigestResponse } from './types';

interface Props {
  data: WeeklyDigestResponse;
  compact?: boolean;
}

const WeeklyDigestView: React.FC<Props> = ({ data, compact = false }) => (
  <div className="space-y-6">
    <div className="bg-purple-50 dark:bg-purple-900/20 p-6 rounded-lg">
      <h2 className="text-2xl font-bold mb-2">Weekly Leadership Digest</h2>
      <p className="text-sm text-muted-foreground">{data.start_date} to {data.end_date}</p>
      <p className={`mt-4 text-foreground ${compact ? 'line-clamp-4' : ''}`}>{data.summary}</p>
    </div>

    {!compact && data.at_risk_accounts?.length > 0 && (
      <div className="border border-red-200 dark:border-red-800 rounded-lg p-6">
        <h3 className="text-xl font-semibold text-red-700 dark:text-red-400 mb-4">
          At-Risk Accounts ({data.at_risk_accounts.length})
        </h3>
        <div className="space-y-4">
          {data.at_risk_accounts.map((account, idx) => (
            <div key={idx} className="p-4 rounded border border-red-200 dark:border-red-800 bg-card">
              <h4 className="font-semibold">{account.customer_name}</h4>
              <p className="text-sm text-muted-foreground">Health: {account.health_score}/100</p>
              <p className="text-sm mt-2">{account.mitigation_plan}</p>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default WeeklyDigestView;
